<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="1"
    y="1"
    width="14"
    height="14"
    rx="3"
    stroke="currentColor"
    fill="transparent"
    stroke-width="2"
  />

  <path
    d="M4.5 8.5L7 11L12 6"
    stroke="currentColor"
    fill="transparent"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
